export const megabytesToBytes = (mega: number) => mega * Math.pow(2, 20);

// Based on https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
export const niceBytes = (x: number | string) => {
  let l = 0;
  let n = parseInt(String(x), 10) || 0;
  while (n >= 1024 && ++l) {
    n = n / 1024;
  }
  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + units[l];
};
